type TableHeaderProps = {
  columns: {
    id: string;
    label: string;
  }[];
};

const TableHeader = ({ columns = [] }: TableHeaderProps) => (
  <thead data-testid="table-header">
    <tr role="row">
      {columns.map(({ id, label }) => (
        <th key={id} scope="col" id={id} rowSpan={1} colSpan={1}>
          {label}
        </th>
      ))}
    </tr>
  </thead>
);

export default TableHeader;
